const TABS = Object.freeze({
    LATE: 'late',
    DONE: 'done',
    TODO: 'todo',
});

export { TABS };
